import { Select } from 'antd';
import 'antd/es/select/style/index';
import './index.less';

export default Select;
